import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Box,
  Chip,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import SchoolIcon from '@mui/icons-material/School';
import CloseIcon from '@mui/icons-material/Close';
import { fetchFaculty } from '../services/api';
import defaultProfileImage from '../assets/default-profile.png';
import luanImage from '../assets/luan.jpg';
import rangelImage from '../assets/rangel.jpeg';
import dayanaImage from '../assets/dayana.jpg';
import rosangelaImage from '../assets/rosangela.png';
import virginiaImage from '../assets/virginia.jpg';
import adrianaImage from '../assets/adriana.jpg';
import adalmireneImage from '../assets/adalmirene.png';
import JanailmaImage from '../assets/janailma.jpg';
import falconImage from '../assets/falcon.jpg';
import aecioImage from '../assets/aecio.jpg';
import augustoImage from '../assets/augusto.jpg';
import ciceroImage from '../assets/cicero.jpg';
import andreImage from '../assets/andre.jpg';
import kalineImage from '../assets/kaline.png';
import sueniaImage from '../assets/suenia.jpg';
import josielImage from '../assets/josiel.jpg';
import beneiltoImage from '../assets/beneilto.jpg';
import ritaImage from '../assets/rita.jpg';
import otacianaImage from '../assets/otaciana.jpg';
import isabelImage from '../assets/isabel.jpg';

const Faculty = () => {
  const [faculty, setFaculty] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedProfessor, setSelectedProfessor] = useState(null);

  
  useEffect(() => {
    const loadFaculty = async () => {
      try {
        setLoading(true);
        // Static data for seven professors
        
        const staticFaculty = [
          {
            id: 16,
            nome: 'Adalmirene Melo',
            disciplina: 'Analises Clinicas',
            email: 'roberto.silva@escola.com',
            formacao: 'Licenciada em biologia.',
            descricao: 'Especialização em ciências ambientais.',
            foto: adalmireneImage
          },
          {
            id: 15,
            nome: 'Aécio Melo',
            disciplina: 'Agroecologia',
            email: 'carla.regina@escola.com',
            formacao: 'Bacharel em Agroecológia',
            descricao: 'Mestrado em tecnologia agroalimentar.',
            foto: aecioImage
          },
          {
            id: 4,
            nome: 'Ana Kaline Delgado',
            disciplina: 'Português',
            email: 'carlos.ferreira@escola.com',
            formacao: 'Licenciatura em Português',
            descricao: '',
            foto: kalineImage
          },
          {
            id: 14,
            nome: 'André Carlos',
            disciplina: 'Agroecologia',
            email: 'joao.victor@escola.com',
            formacao: 'Bacharel em Agroecologia',
            descricao: 'Mestre em Ciências Agrárias (Agroecologia).',
            foto: andreImage
          },
          {
            id: 8,
            nome: 'Augusto',
            disciplina: 'Educação Física',
            email: 'marcos.antonio@escola.com',
            formacao: 'Bacharel em Educação Física e Licenciado em Educação Física',
            descricao: '',
            foto: augustoImage
          },
          {
            id: 9,
            nome: 'Cicero',
            disciplina: 'Geografia',
            email: 'francisca.maria@escola.com',
            formacao: 'Licenciatura em Geografia',
            descricao: '',
            foto: ciceroImage
          },
          
          {
            id: 18,
            nome: 'Isabel Cristina',
            disciplina: 'História',
            email: 'ricardo.souza@escola.com',
            formacao: 'Licenciatura em História',
            descricao: '',
            foto: isabelImage
          },
          {
            id: 13,
            nome: 'Josiel Custodio',
            disciplina: 'Matemática',
            email: 'ana.beatriz@escola.com',
            formacao: 'Licenciatura plena em matemática (UEPB)',
            descricao: 'Especialização em Educação Financeira (UFPB), cursando mestrado profissionalizante',
            foto: josielImage
          },
          {
            id: 1,
            nome: 'Luan Soares',
            disciplina: 'Espanhol',
            email: 'maria.silva@escola.com',
            formacao: 'Graduação em Letras Hab. Plena em Língua Inglesa; Letras Português/ Espanhol; Letras Hab. Plena em LIBRAS; Artes Visuais.',
            descricao: 'Especialização em Metodologia do Ens. Em Língua Espanhola; Arte e Educação; LIBRAS (Língua Brasileira de Sinais), Tecnólogo em LIBRAS.',
            foto: luanImage
          },
          {
            id: 17,
            nome: 'Maria Janailma',
            disciplina: 'Informática',
            email: 'patricia.santos@escola.com',
            formacao: 'Licenciatura em computação',
            descricao: 'Técnica em manutenção e suporte em informática, Pós em psicopedagogia',
            foto: JanailmaImage
          },
          {
            id: 12,
            nome: 'Otaciana Romão',
            disciplina: 'Química',
            email: 'pedro.paulo@escola.com',
            formacao: ' Licenciatura Plena e Bacharelado em Química.',
            descricao: 'Mestranda em Química, Pós-graduação: (Psicopedagogia), (Fundamentos da Educação: Práticas Pedagógicas Interdisciplinares).',
            foto: otacianaImage
          },
          {
            id: 10,
            nome: 'Rafael Leal',
            disciplina: 'Física',
            email: 'jose.carlos@escola.com',
            formacao: 'Licenciatura em Física',
            descricao: 'Doutorado em Física',
            foto: defaultProfileImage
          },
          {
            id: 2,
            nome: 'Rangel Andrade',
            disciplina: 'Informática',
            email: 'joao.santos@escola.com',
            formacao: 'Licenciatura em Computação e Informática, Licenciatura em Educação Física',
            descricao: 'Especializações em NeuroPsicopedagogia e PsicoMotricidade, Análise Comportamental Aplicada ao Autismo (ABA).',
            foto: rangelImage
          },
          {
            id: 11,
            nome: 'Rita Ana',
            disciplina: 'Ciências',
            email: 'maria.helena@escola.com',
            formacao: 'Licenciatura em Ciências Agrárias (UFPB), Licenciatura em Biologia (FAVENE).',
            descricao: 'Especialização no Ensino de Ciências e Matemática (IFPB), Especialização em Agroecologia (UFPB).',
            foto: ritaImage
          },
          {
            id: 7,
            nome: 'Rosângela',
            disciplina: 'Inglês',
            email: 'luciana.martins@escola.com',
            formacao: 'Licenciada em Letras - Português e Inglês ',
            descricao: 'Especialista em técnica redacional e revisão de textos.',
            foto: rosangelaImage
          },
          {
            id: 3,
            nome: 'Suênia Marques',
            disciplina: 'Português',
            email: 'ana.oliveira@escola.com',
            formacao: 'Graduada em Letras Língua Portuguesa,Pedagogia, Arte',
            descricao: 'Especialista em Literatura e Ensino.',
            foto: sueniaImage
          },
          {
            id: 5,
            nome: 'Virginia',
            disciplina: 'Português',
            email: 'patricia.lima@escola.com',
            formacao: 'Licenciatura Plena em Letras e Pedagogia',
            descricao: '',
            foto: virginiaImage
          },
          {
            id: 19,
            nome: 'João Felix',
            disciplina: 'Matemática',
            email: 'fernanda.costa@escola.com',
            formacao: 'Licenciatura Geografia, Física, Matemática, Tecnólogo de Nível Superior.',
            descricao: 'Especialização Metodologia do Ensino da Física, Metodologia do Ensino da Matemática, Técnico em Segundo grau em Administração.',
            foto: falconImage
          },
          {
            id: 20,
            nome: 'Adriana Celi',
            disciplina: 'Biologia',
            email: 'lucas.oliveira@escola.com',
            formacao: 'Licenciatura em Biologia, Graduação em Ciências Agrárias.',
            descricao: 'Especialização em Educação para a Convivência com o Semiárido. Especialização em Educação Digital.',
            foto: adrianaImage
          },
          {
            id: 21,
            nome: 'Beneilton',
            disciplina: 'Sociologia',
            email: 'amanda.lima@escola.com',
            formacao: 'Licenciatura em Filosofia e Sociologia',
            descricao: '',
            foto: beneiltoImage
          }
        ];
        
        // Sort faculty alphabetically by name
        const sortedFaculty = staticFaculty.sort((a, b) => a.nome.localeCompare(b.nome));
        setFaculty(sortedFaculty);
        setError(null);
      } catch (err) {
        setError('Não foi possível carregar os dados dos professores. Por favor, tente novamente mais tarde.');
        console.error('Error loading faculty:', err);
      } finally {
        setLoading(false);
      }
    };

    loadFaculty();
  }, []);
;

  const handleOpenDialog = (professor) => {
    setSelectedProfessor(professor);
  };

  const handleCloseDialog = () => {
    setSelectedProfessor(null);
  };

  if (loading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  if (faculty.length === 0) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert severity="info">Nenhum professor encontrado.</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
        Nossos Professores
      </Typography>

      <Grid container spacing={4}>
        {faculty.map((professor) => (
          <Grid item key={professor.id} xs={12} sm={6} md={4}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'scale(1.02)',
                },
              }}
            >
              <CardMedia
                component="img"
                height="300"
                image={professor.foto}
                alt={professor.nome}
                sx={{ 
                  objectFit: 'cover',
                  backgroundColor: 'grey.100'
                }}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h5" component="h2" gutterBottom>
                  {professor.nome}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                  {professor.disciplina || 'Professor'}
                </Typography>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                  {professor.formacao}
                </Typography>
                {professor.disciplinas && professor.disciplinas.length > 0 && (
                  <Box sx={{ mt: 1, mb: 2 }}>
                    {professor.disciplinas.map((disciplina, index) => (
                      <Chip
                        key={index}
                        label={disciplina}
                        size="small"
                        icon={<SchoolIcon />}
                        sx={{ mr: 1, mb: 1 }}
                      />
                    ))}
                  </Box>
                )}
                <Typography variant="body2" color="text.secondary" sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  mb: 2
                }}>
                  {professor.biografia || professor.descricao}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  {professor.email && (
                    <IconButton
                      color="primary"
                      href={`mailto:${professor.email}`}
                      aria-label="enviar email"
                    >
                      <EmailIcon />
                    </IconButton>
                  )}
                  <Button
                    size="small"
                    onClick={() => handleOpenDialog(professor)}
                  >
                    Ver Mais
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog
        open={Boolean(selectedProfessor)}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        {selectedProfessor && (
          <>
            <DialogTitle sx={{ m: 0, p: 2 }}>
              {selectedProfessor.nome}
              <IconButton
                aria-label="close"
                onClick={handleCloseDialog}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={selectedProfessor.foto}
                  alt={selectedProfessor.nome}
                  sx={{ 
                    objectFit: 'cover', 
                    borderRadius: 1,
                    width: '200px',
                    margin: '0 auto',
                    boxShadow: 1
                  }}
                />
                <Typography variant="h6" gutterBottom>
                  {selectedProfessor.cargo || selectedProfessor.titulo || 'Professor'}
                </Typography>
                {selectedProfessor.formacao && (
                  <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                    Formação: {selectedProfessor.formacao}
                  </Typography>
                )}
                {selectedProfessor.disciplinas && selectedProfessor.disciplinas.length > 0 && (
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>
                      Disciplinas:
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {selectedProfessor.disciplinas.map((disciplina, index) => (
                        <Chip
                          key={index}
                          label={disciplina}
                          icon={<SchoolIcon />}
                        />
                      ))}
                    </Box>
                  </Box>
                )}
                <Typography variant="body1">
                  {selectedProfessor.biografia || selectedProfessor.descricao}
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions>
              {selectedProfessor.email && (
                <Button
                  startIcon={<EmailIcon />}
                  href={`mailto:${selectedProfessor.email}`}
                >
                  Contatar
                </Button>
              )}
              <Button onClick={handleCloseDialog}>Fechar</Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Container>
  );
};

export default Faculty;
